export const MESSAGE_BOX_ERROR = 'MESSAGE_BOX_ERROR'
export const MESSAGE_BOX_SUCCESS = 'MESSAGE_BOX_SUCCESS'
export const MESSAGE_BOX_WARN = 'MESSAGE_BOX_WARN'
